export enum TaskTypeEnum {
    LEGAL_METROLOGY_INSPECTION = 'LEGAL_METROLOGY_INSPECTION',
    CONSUMER_PRICE_INSPECTION = 'CONSUMER_PRICE_INSPECTION'
}

export enum LegalMetroTaskTypeEnum {
    SCALE_FORMAT_VERIFICATION = 'SCALE_FORMAT_VERIFICATION',
    PRE_PACKAGED_PRODUCT_VERIFICATION = 'PRE_PACKAGED_PRODUCT_VERIFICATION',
    FUEL_DISPENSER_VERIFICATION = 'FUEL_DISPENSER_VERIFICATION'
}